import { faCaretDown, faCaretRight } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import React from 'react';
import { Collapse } from 'reactstrap';

class AccordionContainer extends React.Component {

    // Fn: Render the styling of accordion title based on the state of accordion 
    TitleState = () => {
        return (this.props.active) ? 'card-link collapse form-title-active' : 'card-link collapsed form-title';
    };

    // Fn: Render the icon of caret based on the state of accordion 
    Caret = () => {
        return (this.props.active) ? faCaretDown : faCaretRight;
    };

    render() {
        return (
            <div className={"accordion"}>
                <div className="card" onClick={() => this.props.onClick(true, this.props.isIndividual, this.props.title, this.props.sections)} >
                    <div className="card-header">
                        <h2 className={this.TitleState()}>
                                {this.props.title}
                            </h2>
                    </div>
                </div>
                <Collapse className="collapse-content clearfix" isOpen={this.props.active}>
                    <div className="accordion-content">
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        );
    }
}

// PropTypes: For prop validation
AccordionContainer.propTypes = {
    active: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    isIndividual: PropTypes.bool,
    sections: PropTypes.object
};

AccordionContainer.defaultProps = {
    isIndividual: false
};

export default AccordionContainer;